import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RoutingOperation, RoutingOperationCreate, RoutingOperationFilter } from '../data/routingOperation';

export function createRoutingOperationService(client: AxiosInstance) {
  return createCrudService<RoutingOperation, RoutingOperationCreate, RoutingOperationFilter>(
    client,
    '/manufacturing/RoutingOperation',
    'id',
  );
}

export type RoutingOperationService = CrudService<RoutingOperation, RoutingOperationCreate, RoutingOperationFilter>;
